module.exports = __webpack_public_path__ + "static/media/View-Specials-Icon-White.505253d0.svg";